import { useLoginStore, usePersistStore } from '@/shared/lib/store';
import { sendTraceLogDebug } from 'visang-tracker';

const nowLocal = () => {
    const d = new Date();
    const pad = (n: number, len = 2) => n.toString().padStart(len, '0');
    const yyyy = d.getFullYear();
    const MM = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const mm = pad(d.getMinutes());
    const ss = pad(d.getSeconds());
    return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
};

const sendTraceLog = (
    hash?: string,
    errCd?: string,
    tag?: string,
    logType?: string,
    ...message: any[]
) => {
    const { sUserId, sDefaultUserId } = usePersistStore.getState();
    const { memberInfo, loginInfo } = useLoginStore.getState();
    const msg =
        message.length === 1
            ? typeof message[0] === 'string'
                ? message[0]
                : JSON.stringify(message[0])
            : message.map((m) => (typeof m === 'string' ? m : JSON.stringify(m))).join(' ');
    console.log(msg);
    const errorLog = {
        tchId: sDefaultUserId, // 교사 ID
        uuid: sUserId, // 사용자 UUID
        uType: loginInfo.teacherYn === 'Y' ? 'T' : 'S', // 사용자 타입
        uName: loginInfo.name, // 사용자 이름
        cId: memberInfo.schCode, // 학급 ID
        component: window.location.hash, // 오류 발생 위치
        appName: 'SmartBANK',
        logType: logType,
        hash: hash,
        schlNm: memberInfo.schName, // 학교 이름
        errCd: errCd, // 오류 코드
        version: APP_VERSION,
        createdAt: nowLocal(),
        message: msg,
        evtCd: tag,
        profile:
            import.meta.env.VITE_DEPLOY === 'local'
                ? 'vs-dev'
                : 'vs-' + import.meta.env.VITE_DEPLOY,
    };
    sendTraceLogDebug(errorLog);
};

export { sendTraceLog };
